// GenerateAnswers (an action file)

const getRandomIndices = (data) => {

  let dataIndices = Array.from({ length: data.length }, (v, i) => i);
  let indices = [...dataIndices];
  let shuffledIndices = indices.sort(() => 0.5 - Math.random());

  const delCount = shuffledIndices.length % 4;

  const start = shuffledIndices.length - delCount;

  shuffledIndices.splice(start, delCount);


  let finalIndices = [];
  while (shuffledIndices.length >= 4) {
    finalIndices.push(shuffledIndices.splice(0, 4));
  }

  return finalIndices;
}

export default getRandomIndices